import { buildSearchUrlWithSearchString } from './buildSearchUrlWithSearchString'

export const searchByOxomiInfoPlayObject = (infoplayObj) => {
  const base = `${window.location.protocol}//${window.location.host}`
  window.open(`${base}/${buildSearchUrlWithSearchString(infoplayObj.compactSelection)}`, '_blank')
}
